import React, { Component } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Button,
  TextInput,
  Picker,
  ScrollView,
  StyleProp,
  ViewStyle,
  FlatList,
} from "react-native";
import { FONT_SIZE, THEME_COLORS } from "../../styles";
import { FONT_FAMILY } from "../../themes";
import RowComponent from "./RowComponent";

interface IHeaderColumn {
  label: string;
  style: StyleProp<ViewStyle>;
}

interface ITableComponentProps {
  headerColumns: (IHeaderColumn | any)[];
  rowData: (IHeaderColumn | any)[][];
  renderColumn: (object) => JSX.Element;
  selectedRowsId?: any[];
  selectedRowsStyle?: StyleProp<ViewStyle>;
}

const TableComponent = (props: ITableComponentProps) => {
  const { headerColumns, rowData, renderColumn } = props;
  console.warn(headerColumns);

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          alignSelf: "flex-start",
          width: "100%",
          alignContent: "flex-start",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: 10,
          padding: 5,
        }}
      >
        {headerColumns.map((obj, index) => {
          return (
            <View key={index} style={[styles.rowHeaderColumn, obj.style]}>
              <Text style={{ fontFamily: FONT_FAMILY.three, fontSize: 15 }}>
                {obj.label}
              </Text>
            </View>
          );
        })}
      </View>
      <View style={{ flex:1 }} />
      <FlatList
        data={rowData}
        maxToRenderPerBatch={15}
        contentContainerStyle={{ backgroundColor: "#FAFAFA" }}
        removeClippedSubviews={true}
        renderItem={({ item, index }: any) => {
          const isSelected = props.selectedRowsId
            ? props.selectedRowsId?.includes(item?.[0]?.id)
            : false;

          return (
            <View
              key={index}
              style={{
                backgroundColor:
                  index % 2 == 0 ? "rgba(99, 0, 163, 0.05)" : "#FFFFFF",
                width:'100%'
              }}
            >
              <RowComponent row={item} renderColumn={renderColumn} />
            </View>
          );
        }}
      />
    </View>
  );
};

const getCompareObject = (props: any) => {
  const a = props.row.reduce(function (finalObject, obj, index) {
    const d = { ...finalObject, [`value${index}`]: obj.value };
    return d;
  }, {});
  return a;
};
const areEqual = (nextProps: any, prevProps: any) => {
  // const a = shallowEqual(getCompareObject(nextProps), getCompareObject(prevProps));
  return JSON.stringify(nextProps) === JSON.stringify(prevProps);
};

export default React.memo(TableComponent, areEqual);

const styles = StyleSheet.create({
  rowHeaderColumn: {
    flex: 1,
    paddingLeft: 10,
    paddingVertical: 8,
    paddingRight: 2,
  },
});
